import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/** Shared section heading + dotted panel used by the desktop and mobile views. */

export function EngineHeading({
  heading,
  subheading,
}: {
  heading: string;
  subheading: string;
}) {
  return (
    <h2 className="text-grey-950 w-full text-[24px] leading-[1.2] tracking-[-0.04em] md:text-[28px] lg:text-[32px]">
      {heading} <span className="text-grey-500">{subheading}</span>
    </h2>
  );
}

export function EnginePanel({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-ds-xl border-grey-100 bg-grey-0 relative overflow-hidden border",
        className
      )}
      style={{
        // Fade to zero-alpha WHITE, not `transparent` — WebKit interpolates
        // `transparent` through rgba(0,0,0,0) and smears the panel dark grey.
        backgroundImage:
          "linear-gradient(121deg, var(--grey-50) 0%, rgba(255,255,255,0) 100%)",
      }}
    >
      {children}
    </div>
  );
}
